import { Commodity } from '..'

export const getCommodities = (): Commodity[] => {
    return [
        {
            commodityTypeId: 1,
            commodityName: 'Electric',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'MWH',
                    unitOfMeasureId: 1,
                },
            ],
        },
        {
            commodityTypeId: 2,
            commodityName: 'Natural Gas',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'MWH',
                    unitOfMeasureId: 1,
                },
            ],
        },
        {
            commodityTypeId: 3,
            commodityName: 'Water',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'CCF',
                    unitOfMeasureId: 11,
                },
            ],
        },
        {
            commodityTypeId: 4,
            commodityName: 'Waste',
            unitsOfMeasure: [
                {
                    isStandardUnit: true,
                    unit: 'LB',
                    unitOfMeasureId: 13,
                },
            ],
        },
        {
            commodityTypeId: 5,
            commodityName: 'Sewer',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'CCF',
                    unitOfMeasureId: 11,
                },
            ],
        },
        {
            commodityTypeId: 6,
            commodityName: 'CO2',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'MT',
                    unitOfMeasureId: 14,
                },
            ],
        },
        {
            commodityTypeId: 7,
            commodityName: 'Methane',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'MCF',
                    unitOfMeasureId: 25,
                },
            ],
        },
        {
            commodityTypeId: 8,
            commodityName: 'Recycling',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'LB',
                    unitOfMeasureId: 13,
                },
            ],
        },
        {
            commodityTypeId: 10,
            commodityName: 'Propane',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'KBTU',
                    unitOfMeasureId: 7,
                },
            ],
        },
        {
            commodityTypeId: 11,
            commodityName: 'Cleaning',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'Pallets',
                    unitOfMeasureId: 33,
                },
            ],
        },
        {
            commodityTypeId: 12,
            commodityName: 'Irrigation',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'GAL',
                    unitOfMeasureId: 12,
                },
            ],
        },
        {
            commodityTypeId: 13,
            commodityName: 'Stormwater',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'KGAL',
                    unitOfMeasureId: 17,
                },
            ],
        },
        {
            commodityTypeId: 14,
            commodityName: 'Snow and Ice',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'm3',
                    unitOfMeasureId: 46,
                },
            ],
        },
        {
            commodityTypeId: 15,
            commodityName: 'Pest Management',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'KGAL',
                    unitOfMeasureId: 17,
                },
            ],
        },
        {
            commodityTypeId: 16,
            commodityName: 'Rent',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'SF',
                    unitOfMeasureId: 26,
                },
            ],
        },
        {
            commodityTypeId: 17,
            commodityName: 'Postage',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'DCF',
                    unitOfMeasureId: 50,
                },
            ],
        },
        {
            commodityTypeId: 18,
            commodityName: 'Lawn Care',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'HGAL',
                    unitOfMeasureId: 26,
                },
            ],
        },
        {
            commodityTypeId: 19,
            commodityName: 'Security',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'DCF',
                    unitOfMeasureId: 50,
                },
            ],
        },
        {
            commodityTypeId: 20,
            commodityName: 'Office Supplies',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'SF',
                    unitOfMeasureId: 26,
                },
            ],
        },
        {
            commodityTypeId: 21,
            commodityName: 'Miscellaneous',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'CF',
                    unitOfMeasureId: 32,
                },
            ],
        },
        {
            commodityTypeId: 27,
            commodityName: 'Steam',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'CCF',
                    unitOfMeasureId: 11,
                },
            ],
        },
        {
            commodityTypeId: 28,
            commodityName: 'Fuel Gas',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'CCF',
                    unitOfMeasureId: 11,
                },
            ],
        },
        {
            commodityTypeId: 29,
            commodityName: 'Nitrogen',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'SCF',
                    unitOfMeasureId: 11,
                },
            ],
        },
        {
            commodityTypeId: 30,
            commodityName: 'Telecom',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'SCF',
                    unitOfMeasureId: 11,
                },
            ],
        },
        {
            commodityTypeId: 31,
            commodityName: 'Recycled Waste',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'KGAL',
                    unitOfMeasureId: 17,
                },
            ],
        },
        {
            commodityTypeId: 32,
            commodityName: 'Wastewater',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'm3',
                    unitOfMeasureId: 43,
                },
            ],
        },
        {
            commodityTypeId: 33,
            commodityName: 'Recycled Wastewater',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'm3',
                    unitOfMeasureId: 43,
                },
            ],
        },
        {
            commodityTypeId: 34,
            commodityName: 'Chilled Water',
            unitsOfMeasure: [
                {
                    isStandardUnit: false,
                    unit: 'm3',
                    unitOfMeasureId: 43,
                },
            ],
        },
    ]
}
